<script setup>
import { ref, watch, onMounted } from 'vue';
import ReportMetricCard from './ReportMetricCard.vue';
import ReportsAPI from 'dashboard/api/reports';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
});

const conversationCount = ref('0');
const messageCount = ref('0');
const replyTime = ref('0');
const ConversionRate = ref('0');
const ChurnRate = ref('0');
const totalCommissionAmount = ref('0');

const formatToPercent = value => {
  return value ? `${value}%` : '--';
};

const fetchMetrics = () => {
  if (!props.filters.to || !props.filters.from) {
    return;
  }
  ReportsAPI.getCommissionMetrics(
    props.filters.from,
    props.filters.to,
    props.filters.id
  ).then(response => {
    conversationCount.value = response.data.conversation_count.toLocaleString();
    messageCount.value = response.data.message_count.toLocaleString();
    replyTime.value = response.data.avg_reply_time.toLocaleString();
    ConversionRate.value = response.data.conversion_rate.toLocaleString();
    ChurnRate.value = response.data.churn_rate.toLocaleString();
    totalCommissionAmount.value =
      response.data.total_commission_amount.toLocaleString();
  });
};

watch(() => props.filters, fetchMetrics, { deep: true });
</script>

<template>
  <div
    class="flex flex-wrap mx-0 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5"
  >
    <ReportMetricCard
      label="Reply Time(Avg)"
      info-text="Average time taken by an agent to reply to a customer message."
      :value="replyTime"
      class="flex-1"
    />
    <ReportMetricCard
      label="Conversion Rate"
      info-text="The percentage of conversations that lead to a successful outcome, such as resolving an issue or completing a sale."
      :value="formatToPercent(ConversionRate)"
      class="flex-1"
    />
    <ReportMetricCard
      label="Churn Rate"
      info-text="Percentage of users marked as churned (no messages sent in 15 days) out of the total number of users handled."
      :value="formatToPercent(ChurnRate)"
      class="flex-1"
    />
    <ReportMetricCard
      label="Conversations"
      info-text="Total number of conversions handled by agent"
      :value="conversationCount"
      class="flex-1"
    />
    <ReportMetricCard
      label="Messages"
      info-text="Total number of messages send by agent"
      :value="messageCount"
      class="flex-1"
    />
  </div>

  <div
    class="flex flex-wrap mx-0 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5"
  >
    <ReportMetricCard
      label="Total Commissions Amount"
      info-text="The total commission earned for the order, calculated based on the commission rate and order amount."
      :value="totalCommissionAmount"
      class="flex-1"
    />
  </div>
</template>
